import DomainCommon from '../../../service/common';
import UserService from "../../../service/user";
import ReduxUser from "./user";
import cookie from 'react-cookies';
import {authRoles} from "./auth";

const oneYear = 365 * 24 * 60 * 60;

const Action = {
    LOGIN_ERROR: "LOGIN_ERROR",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
};

const getCallHelperPricePlans = ({user}) => {
    if (!user) return []
    if (!user.call_helper) return []
    if (!user.call_helper.call_helper_price_plan) return []

    const price_plans = user.call_helper.call_helper_price_plan.map((price_plan) => {
        return {id: price_plan.price_plan.id, name: price_plan.price_plan.name}
    })
    return price_plans
}

const getCallHelperInstitutions = ({user}) => {
    if (!user) return []
    if (!user.call_helper) return []
    if (!user.call_helper.call_helper_price_plan) return []

    const price_plans = user.call_helper.call_helper_price_plan
        .map((price_plan) => {
            if (!price_plan) return []
            if (!price_plan.price_plan) return []
            if (!price_plan.price_plan.price_plan_institution) return []
            return price_plan.price_plan.price_plan_institution.map((price_plan_institution) => price_plan_institution.fk_institution_id)
        })

    if (!price_plans) return []
    if (price_plans.length === 0) return []
    const reduced_price_plans= price_plans.reduce((list1, list2) => [...list1, ...list2])
    return [...new Set(reduced_price_plans)]
}

const ActionCreator = {
    login({email, password}) {
        return async (dispatch) => {
            try {
                const apiUser = await UserService.login({email, password});
                if (authRoles.user.indexOf(apiUser.role.label) === -1 && (!apiUser.medical || !apiUser.medical.is_admin))
                    throw new Error();
                DomainCommon.setApiToken(apiUser.token);
                cookie.save('apiToken', apiUser.token, {path: '/', maxAge: oneYear});

                const fuseUser = {
                    ...apiUser,
                    roleObj: apiUser.role,
                    role: apiUser.role.label,
                    callCenterPricePlan: getCallHelperPricePlans({user: apiUser}),
                    callCenterInstitution: getCallHelperInstitutions({user: apiUser}),
                    from: 'uecare-api',
                    uuid: apiUser.token,
                    data: {
                        displayName: apiUser.name,
                        email: apiUser.email,
                        photoURL: apiUser.avatar && apiUser.avatar.url
                    }
                };

                dispatch(ReduxUser.ActionCreator.setUserData(fuseUser));

                return dispatch({type: Action.LOGIN_SUCCESS, user: apiUser});
            } catch (error) {
                return dispatch({
                    type: Action.LOGIN_ERROR, payload: {
                        email: "請確認 E-MAIL 是否正確",
                        password: "請確認密碼是否正確",
                    }
                });
            }
        };
    },
    loginWithApiToken({apiToken}) {
        return async (dispatch) => {
            try {
                const apiUser = await UserService.loginWithApiToken({apiToken});
                if (authRoles.user.indexOf(apiUser.role.label) === -1 && (!apiUser.medical || !apiUser.medical.is_admin))
                    throw new Error();
                DomainCommon.setApiToken(apiUser.token);
                cookie.save('apiToken', apiUser.token, {path: '/', maxAge: oneYear});

                const fuseUser = {
                    ...apiUser,
                    roleObj: apiUser.role,
                    role: apiUser.role.label,
                    callCenterPricePlan: getCallHelperPricePlans({user: apiUser}),
                    callCenterInstitution: getCallHelperInstitutions({user: apiUser}),
                    from: 'uecare-api',
                    uuid: '12344de3d',
                    data: {
                        displayName: apiUser.name,
                        email: apiUser.email,
                        photoURL: apiUser.avatar && apiUser.avatar.url
                    }
                };

                dispatch(ReduxUser.ActionCreator.setUserData(fuseUser));

                return dispatch({type: Action.LOGIN_SUCCESS, user: apiUser});
            } catch (error) {
                cookie.remove('apiToken', {path: '/'});
            }
        };
    },
};

const initState = {
    success: false,
    error: {
        email: null,
        password: null
    }
};

function Reducer(state = initState, action) {
    switch (action.type) {
        case Action.LOGIN_SUCCESS: {
            return {
                ...state,
                success: true
            };
        }
        case Action.LOGIN_ERROR: {
            return {
                success: false,
                error: action.payload
            };
        }
        default: {
            return state
        }
    }
}

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/auth/login.js